var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMe } from 'shared/hooks';
import { Box, Heading } from 'shared/components/ui';
import { StatusWrapper } from 'shared/components';
import { InvoicesTable, ProviderPayHeader, useInvoices } from 'src/shared/features/ProviderPay';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { InvoiceCard, DraftInvoiceCard, NotReadyCard, } from 'src/shared/features/ProviderPay/components/InvoiceCard';
import { EHR_DATE_FORMAT } from 'src/shared/features/ProviderPay/constants';
import { partition } from 'src/shared/features/ProviderPay/utils';
/**
 *  The Invoices page which is render to specific providers part of provider pay
 *
 * @returns {React.ReactNode}
 */
export var Invoices = function () {
    var _a, _b, _c;
    var userDetails = useMe();
    var navigate = useNavigate();
    var now = DateTime.fromJSDate(new Date());
    var providerId = (_c = (_b = (_a = userDetails.data) === null || _a === void 0 ? void 0 : _a.care_provider) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : '';
    var _d = useInvoices({
        enabled: providerId.length > 0,
        providerId: providerId,
    }), data = _d.data, isError = _d.isError, isLoading = _d.isLoading, error = _d.error;
    // If for some reason, the user lost the access to this feature, redirect him to another page.
    if ((data === null || data === void 0 ? void 0 : data.providerPayEnabled) === false)
        navigate('/');
    var requestMetadata = { isError: isError, isLoading: isLoading, error: error };
    var _e = useMemo(function () {
        if (data === null || data === void 0 ? void 0 : data.invoices) {
            return partition(data === null || data === void 0 ? void 0 : data.invoices, function (invoice) { return invoice.state === 'draft'; });
        }
        else
            return [[], []];
    }, [data === null || data === void 0 ? void 0 : data.invoices]), draftInvoices = _e[0], finalInvoices = _e[1];
    // Just show not ready card if today is before the 1st and there is no draft shown for the same period
    var showNotReady = useMemo(function () {
        return !draftInvoices.some(function (invoice) {
            var date = invoice.period_start
                ? DateTime.fromFormat(invoice.period_start, EHR_DATE_FORMAT)
                : null;
            return date ? date.month >= now.month && (date === null || date === void 0 ? void 0 : date.year) >= now.year : false;
        });
    }, [draftInvoices]);
    return (_jsxs(Box, __assign({ as: "section" }, { children: [_jsx(ProviderPayHeader, {}), _jsxs(StatusWrapper, __assign({}, requestMetadata, { children: [_jsx(Heading, __assign({ size: "h2", mt: 4, mb: 4, "data-testid": "upcoming-invoices-text" }, { children: "Upcoming Invoices" })), draftInvoices.map(function (draft, index) { return (_jsx(InvoiceCard, { children: _jsx(DraftInvoiceCard, { invoice: draft, index: index }) }, draft.id)); }), showNotReady && (_jsx(InvoiceCard, { children: _jsx(NotReadyCard, {}) })), _jsx(Heading, __assign({ "data-testid": "headerTwo", size: "h2", mt: 5, mb: 4 }, { children: "Past Payments" })), _jsx(InvoicesTable, { data: finalInvoices, isError: isError, isLoading: isLoading })] }))] })));
};
